import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';




@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  showMenu: boolean = false;
  profileUserName: string = '';
  pageTitle: string = '';
  pageActiveName: string ='';
  customerNavbarOn: boolean=false;
  catalogNavbarOn: boolean=false;
  inventoryNavbarOn: boolean=false;


  constructor(  private securityService : SecurityService, private router: Router) { }

  ngOnInit() {
   this.pageActiveName=this.router.url;
   this.customerNavbarOn=this.activateCustomer();
   this.catalogNavbarOn=this.activateCatalog();
   this.inventoryNavbarOn=this.activateInventory();
  }


  logout() {
    this.securityService.logout();
  }

  onActivate(event: any) {
    // window.scroll(0,0);
 
    window.scroll({ 
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
     });
 
     
 }

 activateCustomer(){
  if(this.pageActiveName && (this.pageActiveName=='/customer-data-entry' || this.pageActiveName=='/create-customer'
  || this.pageActiveName.startsWith('/update-customer') )){
    return true;
  }else{
    return false;
  };
 }

 activateCatalog(){
  if(this.pageActiveName && (this.pageActiveName=='/catalog-view' 
  || this.pageActiveName.startsWith('/tariff-and-option-view') 
  || this.pageActiveName.startsWith('/bundled-product-offering-view')
  || this.pageActiveName.startsWith('/handset-view'))){
    return true;
  }else{
    return false;
  };
 }

 activateInventory(){
  if(this.pageActiveName && (this.pageActiveName=='/inventory-view' 
  || this.pageActiveName.startsWith('/product-relationship-view'))){
    return true;
  }else{
    return false;
  };
 }

 

  

}
